import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./transport.css";

export default function AddBus() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [staff,  setStaff]  = useState({ drivers: [], cleaners: [], incharges: [] });
  const [saving, setSaving] = useState(false);
  const [form,   setForm]   = useState({
    bus_number: "", route_name: "", start_point: "", end_point: "",
    start_time: "", arrival_time: "", total_seats: 40,
    driver: "", cleaner: "", incharge: "",
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const loadStaff = async () => {
    try {
      const res = await API.get("/school-admin/buses/staff/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setStaff(res.data);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { loadStaff(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.bus_number.trim() || !form.route_name.trim())
      return alert("Bus number and route name are required");
    try {
      setSaving(true);
      await API.post("/school-admin/buses/add/", form, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      navigate("/school-admin/transport/buses");
    } catch (err) { console.error(err); alert("Failed to create bus"); }
    finally { setSaving(false); }
  };

  return (
    <div className="tr-page">

      {/* ══ HERO ══ */}
      <div className="tr-hero">
        <div className="tr-hero-left">
          <div className="tr-hero-icon">🚍</div>
          <div>
            <h2 className="tr-hero-title">Add New Bus</h2>
            <p className="tr-hero-sub">Register a new school bus with route &amp; staff</p>
          </div>
        </div>
        <div className="tr-hero-right">
          <button className="tr-btn-back" onClick={() => navigate("/school-admin/transport/buses")}>
            ← Back
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit}>

        {/* ── Route & Timing ── */}
        <div className="tr-form-card">
          <p className="tr-form-title">Bus & Route Details</p>
          <div className="tr-grid-2">
            <div className="tr-field">
              <label>Bus Number *</label>
              <input required placeholder="e.g. KL-09-1234" value={form.bus_number}
                onChange={e => set("bus_number", e.target.value)} />
            </div>
            <div className="tr-field">
              <label>Route Name *</label>
              <input required placeholder="e.g. City Route A" value={form.route_name}
                onChange={e => set("route_name", e.target.value)} />
            </div>
            <div className="tr-field">
              <label>Start Point *</label>
              <input required placeholder="Departure stop" value={form.start_point}
                onChange={e => set("start_point", e.target.value)} />
            </div>
            <div className="tr-field">
              <label>End Point *</label>
              <input required placeholder="Final stop" value={form.end_point}
                onChange={e => set("end_point", e.target.value)} />
            </div>
            <div className="tr-field">
              <label>Departure Time *</label>
              <input type="time" required value={form.start_time}
                onChange={e => set("start_time", e.target.value)} />
            </div>
            <div className="tr-field">
              <label>Arrival Time *</label>
              <input type="time" required value={form.arrival_time}
                onChange={e => set("arrival_time", e.target.value)} />
            </div>
            <div className="tr-field">
              <label>Total Seats</label>
              <input type="number" min="1" value={form.total_seats}
                onChange={e => set("total_seats", Math.max(1, parseInt(e.target.value || "1", 10)))} />
            </div>
          </div>
        </div>

        {/* ── Staff Assignment ── */}
        <div className="tr-form-card">
          <p className="tr-form-title">Staff Assignment</p>
          <div className="tr-grid-2">
            <div className="tr-field">
              <label>Driver *</label>
              <select required value={form.driver} onChange={e => set("driver", e.target.value)}>
                <option value="">— Select Driver —</option>
                {staff.drivers.map(d => (
                  <option key={d.id} value={d.id}>{d.name} {d.phone ? `(${d.phone})` : ""}</option>
                ))}
              </select>
            </div>
            <div className="tr-field">
              <label>Cleaner</label>
              <select value={form.cleaner} onChange={e => set("cleaner", e.target.value)}>
                <option value="">— Select Cleaner —</option>
                {staff.cleaners.map(c => (
                  <option key={c.id} value={c.id}>{c.name} {c.phone ? `(${c.phone})` : ""}</option>
                ))}
              </select>
            </div>
            {staff.incharges && staff.incharges.length > 0 && (
              <div className="tr-field">
                <label>Incharge</label>
                <select value={form.incharge} onChange={e => set("incharge", e.target.value)}>
                  <option value="">— Select Incharge —</option>
                  {staff.incharges.map(i => (
                    <option key={i.id} value={i.id}>{i.name} {i.phone ? `(${i.phone})` : ""}</option>
                  ))}
                </select>
              </div>
            )}
          </div>
        </div>

        <button type="submit" className="tr-btn-submit" disabled={saving}>
          {saving ? <><div className="tr-spinner"></div> Saving…</> : "🚍 Save Bus"}
        </button>
      </form>

    </div>
  );
}
